import {
  ParamValueCellRenderer,
  NameCellRenderer,
  VendorTypeCellRenderer,
} from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } =
  TABLE_INFO.ONPREM_LOWEST_CVE_SCORE;

export const  onPremLowestCveScoresColumnDefs = [
  {
    headerName: tableHeader.NAME,
    field: tableProps.NAME,
    flex: 3,
    cellRenderer: NameCellRenderer,
    cellRendererParams: {
      fieldMapping: {
        ...tableProps,
      },
    },
    filter: false,
    // Keep Name column fixed
    lockPosition: true,
    lockPinned: true,
  },
  {
    headerName: "Vendor-Type",
    field: "vendor",
    flex: 3,
    cellRenderer: VendorTypeCellRenderer,
    filter: false,
    sortable: true,
  },
  // {
  //   headerName: tableHeader.CVE_SCORE,
  //   field: tableProps.CVE_SCORE,
  //   flex: 2.5,
  //   cellRenderer: CveScoreCellRenderer,
  //   filter: false,
  //   sortable: true,
  //   // sort: "asc",
  // },
  {
    headerName: tableHeader.CVE_COUNT,
    field: tableProps.CVE_COUNT,
    flex: 2,
    filter: false,
    cellRenderer: ParamValueCellRenderer,
    valueGetter: (params: { data: { cve: number } }) => {
      const cveCount = params.data.cve;
      return cveCount ? cveCount : 0;
    },
    sortable: true,
    sort:"desc"
  },
];
